<template>
  <div>
    <el-dialog title="添加跟进记录"
               :visible.sync="showfollowpicker"
               width="700px"
               append-to-body
               :before-close="close">
      <el-form :model="form"
               ref="form"
               :rules="rules"
               label-width="80px"
               :inline="false"
               size="mini">
        <el-form-item label="日志类型">
          <el-radio-group v-model="form.type">
            <el-radio v-for="(item, index) in typesarr"
                      :key="index"
                      :label="item"
                      border>
              {{item}}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker v-model="form.date"
                          type="date"
                          placeholder="选择日期时间"
                          value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="金额">
          <el-input type="number"
                    v-model="form.amount"
                    placeholder="进输入交易金额"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="照片">
          <div class="flex-box">
            <div class="img-warp flex-box">
              <div class="img-cell"
                   v-for="(item, index) in form.imgs"
                   :key="index">
                <el-image class="imgs"
                          :src="item.path"
                          fit="contain"
                          :lazy="true"></el-image>
              </div>
            </div>
            <div class="upl-warp">
              <el-upload class="upload-demo"
                         drag
                         action="/api/Upload/uploadFile/"
                         :on-success="handleUploadSuccess"
                         :before-upload="beforeUpload"
                         :show-file-list="false"
                         multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </el-upload>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea"
                    v-model="form.remark"
                    placeholder="请输入备注情况"
                    clearable
                    maxlength="1000"
                    show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     @click="confirm">立即创建</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AddClientFollow',
  data () {
    return {
      form: {
        imgs: [],
        type: '',
        date: '',
        amount: '',
        remark: '',
        admin: '',
      },
      rules: {

      },
      typesarr: ['回访', '带看', '认筹', '交押金', '网签'],
    }
  },
  props: {
    cid: {
      type: String,
      default: '',
    },
  },
  computed: {
    showfollowpicker: {
      get () {
        return this.$store.getters.getshowfollowpicker;
      },
      set (val) {
        this.$store.commit('setshowfollowpicker', val);
      },
    }
  },
  mounted () {
    var user = this.$store.getters.getuser;
    this.form.admin = user.realName;
  },
  methods: {
    close () {
      this.$store.commit('setshowfollowpicker', false);
    },
    confirm () {
      var params = {
        id: this.cid,
        type: this.form.type,
        date: this.form.date,
        amount: this.form.amount,
        imgs: JSON.stringify(this.form.imgs),
        remark: this.form.remark,
        admin: this.form.admin,
      }
      this.$api.addProjectFollow(params).then(
        data => {
          this.$message.success(data);
          this.close();
        }
      )
    },
    handleUploadSuccess (res) {
      let { data, errCode, msg } = res;
      if (data) {
        this.$message.success(msg);
        var obj = {
          path: data,
        }
        this.form.imgs.push(obj);
      } else {
        this.$message.error(msg);
      }
    },
    beforeUpload (file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      // const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isJPG && !isPNG) {
        this.$message.error('只能上传图片，不能上传其他文件!');
      }
      // if (!isLt2M) {
      //     this.$message.error('上传的图片大小不能超过 1MB!');
      // }

      return isJPG || isPNG;
    },
  },
}
</script>

<style lang="scss" scoped>
.img-warp {
  .img-cell {
    margin-right: 10px;
    .imgs {
      width: 140px;
      height: 180px;
      border: 1px dashed #d9d9d9;
      box-sizing: border-box;
    }
  }
}
.upl-warp {
  .upload-demo {
    ::v-deep .el-upload-dragger {
      width: 140px;
      height: 180px;
      border-radius: 0;
    }
  }
}
</style>